// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  newsId: __t.u64().primaryKey().name("news_id"),
  kind: __t.string(),
  source: __t.string(),
  headline: __t.string(),
  bodyMd: __t.string().name("body_md"),
  url: __t.option(__t.string()),
  taskTagsJson: __t.string().name("task_tags_json"),
  createdAt: __t.i64().name("created_at"),
});
